import UIDs from "../../../../UIDs";

const uid = UIDs.screens.me.editBankAccount;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    SAVE_BANK_ACCOUNT_ASYNC: `${uid}.saveBankAccountAsync`,
    SAVE_BANK_ACCOUNT_SUCCESS: `${uid}.saveBankAccountSuccess`,
    SAVE_BANK_ACCOUNT_FAILURE: `${uid}.saveBankAccountFailure`,
    DELETE_BANK_ACCOUNT_ASYNC: `${uid}.deleteBankAccountAsync`,
    DELETE_BANK_ACCOUNT_SUCCESS: `${uid}.deleteBankAccountSuccess`,
    DELETE_BANK_ACCOUNT_FAILURE: `${uid}.deleteBankAccountFailure`,
    SET_STATE: `${uid}.setState`
};

export { ActionTypes };